import latte from "refractor/latte";
export default latte;